const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

export const countryName = (value: string): string => {
  // Existing full names and unknown values remain usable as filter values.
  if (!/^[a-z]{2}$/i.test(value)) return value;
  return regionNames.of(value.toUpperCase()) ?? value;
};
